import { useSelector } from "react-redux";
import { CallIcon } from "../utils/svg";

function ChatBtnConsult(props) {
  const { isShowButtons } = props;
  const { userConsult, userConsultIsLoading } = useSelector((state) => state.users);
  const isConsultLoaded = userConsult.id;

  if (!isConsultLoaded) {
    return <a className={`btn btn_primary btn_small chat__btn chat__btn_hidden`} href="#"></a>;
  }

  return (
    <a className={`btn btn_primary btn_small chat__btn${isShowButtons ? "" : " chat__btn_hidden"}`} href={!userConsultIsLoading && userConsult.attributes["phone-href"]}>
      <CallIcon />
      <div className="chat__btn-hint">Позвонить</div>
    </a>
  );
}

export default ChatBtnConsult;
